import { AppBar, Box, Button, Card, CardHeader, Fab, Tab, Tabs, Toolbar, Typography } from '@mui/material';
import { Container } from '@mui/system';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ExpertProfile from '../components/ExpertProfile';
import GoogleCalendar from '../components/GoogleCalendar';
import GoogleCalendarsPicker from '../components/GoogleCalendarsPicker';
import TabPanel from '../components/TabPanel';
import WorkingHours from '../components/WorkingHours/WorkingHours';
import WorkingHoursServices from '../components/WorkingHours/WorkingHoursServices';
import GroupSessionsTab from '../components/tabs/GroupSessionsTab';
import OneToOneSessionsTab from '../components/tabs/OneToOneSessionsTab';
import Payments from '../components/tabs/Payments';
import InfoPage from '../components/tabs/InfoPage';
import constants from '../config/constants';
import userContext from '../context/user.context';
import { AlertContext } from '../context/alert.context';
import { useLanguage } from '../context/language.context';
import useFetch from '../hooks/useFetch';
import { IExpert, IPrivateService } from '../types';
import Reviews from '../components/tabs/Reviews';
import PrivateServicesTable from '../components/PrivateServicesTable';
import InfoPageTherapist from '../components/tabs/InfoPageTherapist';
import FloatingChatButton from '../components/FloatingChatButton';

const Main = () => {
	const navigate = useNavigate();
	const [activeTab, setActiveTab] = useState(0);
	const auth = useContext(userContext);
	const alert = useContext(AlertContext);
	const { t, dir, lang, setLang } = useLanguage();
	const profile = useFetch<IExpert>(`${constants.API_URL}/instructor/admin/profile`);

	const handleActivateAccount = async () => {
		if (!profile?.data?._id) {
			alert?.showAlert(t('missingExpertId'), 'error');
			return;
		}

		try {
			await axios.post(`${constants.API_URL}/instructor/set_instructor_level3`, {
				id: profile.data._id
			});
			alert?.showAlert(t('requestSent'), 'success');
			profile.refetch();

		} catch (error: any) {
			alert?.showAlert(error?.response?.data?.message || t('somethingWentWrong'), 'error');
		}
	};

	useEffect(() => {
		const handleVisibilityChange = () => {
		  if (document.visibilityState === "hidden") {
			localStorage.setItem("lastHiddenTime", Date.now().toString());
		  } else if (document.visibilityState === "visible") {
			const lastHidden = parseInt(localStorage.getItem("lastHiddenTime") || "0", 10);
			const now = Date.now();
			const diffMinutes = (now - lastHidden) / (1000 * 60);

			if (diffMinutes > 30) {
			  auth.logout();
			  navigate('/');
			}
		  }
		};

		document.addEventListener("visibilitychange", handleVisibilityChange);
		return () => {
		  document.removeEventListener("visibilitychange", handleVisibilityChange);
		};
	  }, []);

	  const checkIfSafeSpace = (profile: any) => {
		console.log('profile', profile);
		return profile?.safe_space;
	  };
	return (
		<>
			<AppBar position='fixed' style={{ backgroundColor: 'white' }} elevation={2} dir={dir}>
				<Toolbar style={{ minHeight: 0, paddingBlock: 4 }}>
					<Box px={2}>
						<img alt='grouphug-logo' src='/images/grouphug-wide-logo.png' height={30} width={120} />
					</Box>
					<Typography variant='h5' color='InfoText' sx={{ flexGrow: 1 }}>
						{profile?.data?.name || t('loading')}
					</Typography>
					<Button
						size='small'
						variant='outlined'
						onClick={() => setLang(lang === 'he' ? 'en' : 'he')}
						sx={{ mr: 1, ml: 1, minWidth: 48, fontWeight: 'bold', borderRadius: 2 }}
					>
						{lang === 'he' ? 'EN' : 'עב'}
					</Button>
					<Button
						color='error'
						onClick={() => {
							auth.logout();
							navigate('/');
						}}>
						{t('logout')}
					</Button>
				</Toolbar>
			</AppBar>
			<Container style={{ paddingBlockEnd: 20, paddingBlockStart: 44 }} maxWidth='lg'>
				<Box textAlign={'center'}></Box>
				<Box>
					<Tabs
						variant='fullWidth'
						style={{ direction: dir }}
						centered
						value={activeTab}
						onChange={(e, v) => setActiveTab(v)}
						textColor='primary'>
						<Tab style={{fontWeight: 'bold'}} label={t('tabProfile')} iconPosition='start' />
						<Tab style={{fontWeight: 'bold'}} label={t('tabWorkingHours')} />
						<Tab style={{fontWeight: 'bold'}} label={t('tabMeetingsCalendar')} />
						<Tab style={{fontWeight: 'bold'}} label={t('tabReviews')} />
						<Tab style={{fontWeight: 'bold'}} label={t('tabPayments')} />
						<Tab style={{fontWeight: 'bold'}} label={t('tabGroupSessions')} />
						<Tab style={{fontWeight: 'bold'}} label={t('tabCalendarSync')} />
						<Tab style={{fontWeight: 'bold'}} label={t('tabInfoPage')} />
					</Tabs>
				</Box>

				<TabPanel index={0} value={activeTab}>
					<>
						<Card dir={dir} style={{ marginTop: 20 }}>
							<CardHeader title={t('expertProfile')} />
							<ExpertProfile profileData={profile.data} />
						</Card>
					</>
				</TabPanel>


				<TabPanel index={1} value={activeTab}>
					<Card dir={dir}>
						<CardHeader title={t('myWorkingHours')} />

						{profile.data?._id == '657816c48820fc08ce8b3de7' ? <WorkingHoursServices profileData={profile.data} /> : <WorkingHoursServices profileData={profile.data} />}
					</Card>
				</TabPanel>




				<TabPanel index={2} value={activeTab}>
					<OneToOneSessionsTab profileData={profile.data} />
				</TabPanel>

				<TabPanel index={3} value={activeTab}>
					<Reviews />
				</TabPanel>


				<TabPanel index={4} value={activeTab}>
					<Payments />
				</TabPanel>

				<TabPanel value={activeTab} index={5}>
					<GroupSessionsTab />
				</TabPanel>



				<TabPanel index={6} value={activeTab}>
					<Box p={2}>
						<GoogleCalendar
							checkSyncURL={`${constants.API_URL}/instructor/${profile.data?._id}/check_google`}
							linked={Boolean(profile?.data?.google?.access_token)}
							onButtonClicked={() => {
								window.open(`${constants.API_URL}/instructor/google/${profile?.data?._id}`);
							}}
						/>
						{/* GH-761: pick which Google calendars block availability (renders only when Google is connected) */}
						{constants.CALENDAR_PICKER_ENABLED && Boolean(profile?.data?.google?.access_token) && <GoogleCalendarsPicker />}
					</Box>
				</TabPanel>
				<TabPanel value={activeTab} index={7}>

				{checkIfSafeSpace(profile?.data) ? <InfoPageTherapist /> :<InfoPage />}

				</TabPanel>

			</Container>
			{profile?.data?.inStep == 4 && <Fab
				variant="extended"
				color="primary"
				onClick={handleActivateAccount}
				sx={{
					position: 'fixed',
					bottom: 24,
					left: 24,
					zIndex: 1000,
					direction: dir
				}}
			>
		{t('finishedSettingProfile')}
			</Fab>}
				<FloatingChatButton profileData={profile?.data} />
		</>
	);
};
export default Main;
